import { flagEmoji } from '../../lib/countries';
import { useLabels } from '../../i18n/labels';

interface Props {
  code: string;
  /** 'sm' for cards (10-11px), 'md' for headers (default), 'lg' for Ring Display */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_CLASS: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'text-base leading-none',
  md: 'text-lg leading-none',
  lg: 'text-3xl leading-none',
};

/**
 * Read-only country indicator. Renders the ISO 3166-1 alpha-2 regional-
 * indicator emoji pair — actual flag on iOS / Android / macOS / Linux,
 * regional-indicator letters ("LT") on Windows where Segoe UI Emoji has
 * no flag glyphs. Single token everywhere; the localized name is the
 * accessible name of the flag (#661), not visible text.
 *
 * Flag + localized name belongs in the CountryPicker dropdown (where the
 * user is actively choosing) — every other surface uses this.
 */
export default function CountryDisplay({ code, size = 'md', className = '' }: Props) {
  const { t, countryName } = useLabels();
  return (
    <span
      role="img"
      className={`inline-block ${SIZE_CLASS[size]} ${className}`}
      aria-label={`${t.country.label}: ${countryName(code)}`}
    >
      {flagEmoji(code)}
    </span>
  );
}
